import React, { useState } from "react";
import { t } from "../i18n";

const isImageIcon = (icon) =>
  typeof icon === "string" && (icon.startsWith("data:") || icon.startsWith("http") || /\.(png|jpe?g|svg|gif|webp)$/i.test(icon));

const isTransparentColor = (value) =>
  value == null || value === "" || value === "none" || value === "transparent";

const ICON_BASE_PX = 18;
const EMOJI_BASE_PX = 15;

const resolveIconScale = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return 1;
  }
  return Math.min(2, Math.max(1, n));
};

// Collapsed accordion listing a product's allergens.
// displayMode (venue.allergen_display): 'icon' | 'text' | 'both'
export default ({ allergens, displayMode }) => {
  const [open, setOpen] = useState(false);
  const list = (allergens || []).slice().sort((a, b) => (a.position || 0) - (b.position || 0));

  if (!list.length) return null;

  const mode = ["icon", "text", "both"].includes(displayMode) ? displayMode : "both";

  return (
    <div className='product-allergens'>
      <div className='product-allergens-header' onClick={() => setOpen(!open)}>
        <span className='product-allergens-title'>{t("Products.allergens")}</span>
        <span className={`product-allergens-chevron ${open ? "open" : ""}`}>&#8250;</span>
      </div>
      {open ? (
        <div className='product-allergens-list'>
          {list.map((a) => {
            // hide_name forces icon-only rendering regardless of venue display mode
            const hideName = !!a.hide_name;
            const showIcon = hideName || mode === "icon" || mode === "both";
            const showText = !hideName && (mode === "text" || mode === "both");
            const scale = resolveIconScale(a.icon_scale == null ? 1 : a.icon_scale);
            const iconSize = ICON_BASE_PX * scale;
            const textStyle = {
              ...(a.text_bold ? { fontWeight: 700 } : {}),
              ...(a.text_italic ? { fontStyle: "italic" } : {}),
              ...(a.text_underline ? { textDecoration: "underline" } : {}),
            };
            return (
              <div
                className='product-allergen-item'
                key={a.id}
                title={a.name}
                style={{
                  ...(!isTransparentColor(a.bg_color) ? { backgroundColor: a.bg_color } : {}),
                  ...(!isTransparentColor(a.color) ? { color: a.color } : {}),
                }}
              >
                {showIcon && a.icon ? (
                  isImageIcon(a.icon) ? (
                    <img
                      className='product-allergen-icon'
                      src={a.icon}
                      alt={a.name}
                      style={{ height: iconSize, width: iconSize }}
                    />
                  ) : (
                    <span
                      className='product-allergen-emoji'
                      style={{ fontSize: `${Math.round(EMOJI_BASE_PX * scale)}px` }}
                    >
                      {a.icon}
                    </span>
                  )
                ) : null}
                {showText ? (
                  <span className='product-allergen-name' style={textStyle}>{a.name}</span>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};
